// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-management-user .container {\n  height: 100%;\n}\n.page-management-user .container .el-aside {\n  padding: 10px;\n  border-right: 1px solid #cfd7e5;\n}\n.page-management-user .container .el-main {\n  padding: 0px;\n}", ""]);
// Exports
module.exports = exports;
